/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CheckRevertMovedOutEligibility200ResponseData } from './CheckRevertMovedOutEligibility200ResponseData';
import {
    CheckRevertMovedOutEligibility200ResponseDataFromJSON,
    CheckRevertMovedOutEligibility200ResponseDataFromJSONTyped,
    CheckRevertMovedOutEligibility200ResponseDataToJSON,
} from './CheckRevertMovedOutEligibility200ResponseData';

/**
 * 
 * @export
 * @interface CheckRevertMovedOutEligibility200Response
 */
export interface CheckRevertMovedOutEligibility200Response {
    /**
     * 
     * @type {CheckRevertMovedOutEligibility200ResponseData}
     * @memberof CheckRevertMovedOutEligibility200Response
     */
    data?: CheckRevertMovedOutEligibility200ResponseData;
}

/**
 * Check if a given object implements the CheckRevertMovedOutEligibility200Response interface.
 */
export function instanceOfCheckRevertMovedOutEligibility200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CheckRevertMovedOutEligibility200ResponseFromJSON(json: any): CheckRevertMovedOutEligibility200Response {
    return CheckRevertMovedOutEligibility200ResponseFromJSONTyped(json, false);
}

export function CheckRevertMovedOutEligibility200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckRevertMovedOutEligibility200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : CheckRevertMovedOutEligibility200ResponseDataFromJSON(json['data']),
    };
}

export function CheckRevertMovedOutEligibility200ResponseToJSON(value?: CheckRevertMovedOutEligibility200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CheckRevertMovedOutEligibility200ResponseDataToJSON(value.data),
    };
}

